export default __webpack_public_path__ + "static/media/instagram_icon.2f7eb39b.svg";